import type { SVGProps } from 'react';
const SvgSimCardAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#sim_card_alert_svg__a)">
      <path
        fill="currentColor"
        d="M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm-5 15h-2v-2h2v2Zm0-4h-2V8h2v5Z"
      />
    </g>
    <defs>
      <clipPath id="sim_card_alert_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSimCardAlert;
